import { SpinnerWrapper } from "./styles";

export default function Spinner() {
  return <SpinnerWrapper />;
}
